/* app-switcher.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U1Y8M%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL41Y8M%7Bpadding-inline%3Avar(--ds-space-050%2C4px)%7D");
import React, { forwardRef, type Ref } from 'react';
import AppSwitcherIcon from '@atlaskit/icon/core/app-switcher';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { IconButton } from '../IconButton';
import { type AppSwitcherProps } from './types';
const iconSpacingStyles = {
  space050: "_4c065U1Y8M _2Y7lL41Y8M"
};

/**
 * _App switcher__
 *
 * An AppSwitcher button that can be passed into `AtlassianNavigation`'s
 * `renderAppSwitcher` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#app-switcher)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 *
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */
export const AppSwitcher: React.ForwardRefExoticComponent<React.PropsWithoutRef<AppSwitcherProps> & React.RefAttributes<any>> = forwardRef((props: AppSwitcherProps, ref: Ref<any>) => {
  const {
    component,
    href,
    id,
    isDisabled,
    isSelected,
    label,
    onBlur,
    onClick,
    onFocus,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    onMouseUp,
    target,
    testId,
    tooltip,
    ...rest
  } = props;
  return <IconButton component={component} href={href} icon={<Flex xcss={iconSpacingStyles.space050}>
					<AppSwitcherIcon color="currentColor" label={typeof tooltip === 'string' ? tooltip : 'Switch apps'} />
				</Flex>} id={id} isDisabled={isDisabled} isSelected={isSelected} label={label} onBlur={onBlur} onClick={onClick} onFocus={onFocus} onMouseDown={onMouseDown} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseUp={onMouseUp} ref={ref} target={target} testId={testId} tooltip={tooltip}
  // These are all explicit, leaving it in just in case
  {...rest} />;
});